import { withTranslation } from "react-i18next";
import SideBarSection from "./Layout/SideBarSection";
import Header from "./Header/Header";
import MobileFooter from "./MobileDesign/MobileFooter";
import { Outlet } from "react-router-dom"
import { useSelector } from "react-redux";
import CoachMarkPopup from "./Modal/CoachMarkPopup";

function HomePage(props) {
  const { setLoginHeader } = props;
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  return (
    <>
      <Header setLoginHeader={setLoginHeader} />
      <SideBarSection />
      <Outlet />
      <MobileFooter />
      {/* {currentStep===11 &&  <div id="coachmark11"> <CoachMarkPopup/></div>} */}
      {currentStep === 11 && window.innerWidth > 1024 && (
        <div id="coachmark11">
        <CoachMarkPopup />
    </div>
)}
    </>
  );
}
export default withTranslation()(HomePage);
